module.exports = __webpack_public_path__ + "img/93.8304529f.jpg";